/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagecolumnquantity3Inputs */

const en_ticketpagecolumnquantity3 = /** @type {(inputs: Ticketpagecolumnquantity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qty`)
};

const de_ticketpagecolumnquantity3 = /** @type {(inputs: Ticketpagecolumnquantity3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl`)
};

/**
* | output |
* | --- |
* | "Qty" |
*
* @param {Ticketpagecolumnquantity3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagecolumnquantity3 = /** @type {((inputs?: Ticketpagecolumnquantity3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagecolumnquantity3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagecolumnquantity3(inputs)
	return de_ticketpagecolumnquantity3(inputs)
});
export { ticketpagecolumnquantity3 as "ticketPageColumnQuantity" }